import { mapMediaFileDtoToMediaFile } from '../mappers/map-foldersdto-to-folders.ts'
import { MediaFileService } from '@/features/media-file/data/media-file.service.ts'
import type { MediaFile } from '../models/media-file.ts'

export const fetchFileInfo = async (fileId: string): Promise<MediaFile> => {
  const file = await MediaFileService.getFileInfo(fileId)
  return mapMediaFileDtoToMediaFile(file)
}
